import _Vue, { VNodeDirective, VNode } from 'vue';

enum modification {
    DELETE,
    DISABLE,
}

export function WxHasPlugin(Vue: typeof _Vue, options?: any) {
    // add directive
    Vue.directive('has', (el: HTMLElement, binding: VNodeDirective, vnode: VNode) => {
        if (!vnode.context) return;

        const modify = binding.modifiers && binding.modifiers.disable ? modification.DISABLE : modification.DELETE;
        let neededPrivilege: string[] | string = binding.value;
        if (typeof neededPrivilege === 'string') neededPrivilege = [neededPrivilege];

        if (neededPrivilege) {
            const hasPrivilege = neededPrivilege.every((v) => options.privileges().includes(v));
            if (hasPrivilege) return;
        }

        if (modify === modification.DELETE) commentNode(el, vnode);
        else if (modify === modification.DISABLE) {
            el.setAttribute('disabled', 'disabled');
            // needed for vuetify, other solution?
            el.classList.add('v-btn--disabled');
        }
    });
}

/**
 * Create comment node
 *
 * @private
 * @author https://stackoverflow.com/questions/43003976/a-custom-directive-similar-to-v-if-in-vuejs#43543814
 * @author https://github.com/PxyUp/vue-not-visible/blob/master/src/index.js
 */
function commentNode(el: HTMLElement, vnode: VNode) {
    const comment = document.createComment(' ');

    Object.defineProperty(comment, 'setAttribute', {
        value: () => undefined,
    });

    vnode.text = ' ';
    vnode.elm = comment;
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;

    if (vnode.data) vnode.data.directives = undefined;

    // if (vnode.componentInstance) {
    //     vnode.componentInstance.$el = comment;
    // }

    if (el.parentNode) {
        el.parentNode.replaceChild(comment, el);
    }
}
